import { orderRequestConstants } from "../_constants/order-request.constants";
import {
  dispatchSearchFunds,
  dispatchSearchPortfolios,
} from "../_utils/order-request.utils";

const initialState = {
  // Modal State
  isOpenModal: false,

  // Active tab
  activeTab: "Buy", // (eg. 'Buy', 'Sell', 'Switch')
  subActiveTab: "SINGLE", // (eg. 'SINGLE', 'DCA', 'BOTH')
  navigationFund: null,
  checkedFundAbleToOrder: {
    isFetching: false,
    data: null,
    errorMessage: null,
  },
  orderRequestForm: null,

  // Fund Infomation
  fundInfo: {
    isFetching: false,
    data: null,
    errorMessage: null,
  },

  fundInfo2: {
    isFetching: false,
    data: null,
    errorMessage: null,
  },

  confirmOrderFund: {
    isFetching: false,
    data: null,
    errorMessage: null,
  },

  isFetching: false,
  responseMessage: [],
  searchFundInfo: [],
  searchText: null,
  showResponseMessage: false,
  errorMessage: null,

  // form
  latestPlan: {},
  latestSettleDate: {},
};

const orderRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    // Toggled Buy-Sell Modals.
    case orderRequestConstants.TOGGLED_ORDER_FUNDS_REQUEST_MODAL:
      return {
        ...state,
        isOpenModal: !state.isOpenModal,
        fundId: state.isOpenModal ? null : state.fundId,
      };
    case orderRequestConstants.CLEAR_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: null,
        // showResponseMessage: false
      };
    // Updated Active Tab (buy, sell, switch).
    case orderRequestConstants.UPDATE_ACTIVE_TAB_ORDER_FUNDS_REQUEST_MODAL: {
      const { activeTab, subActiveTab } = action.payload;
      if (
        !action.payload ||
        (activeTab === state.activeTab && subActiveTab === state.subActiveTab)
      ) {
        return state;
      }

      let resetSubActiveTab = subActiveTab ?? state.subActiveTab;
      if (activeTab === "Buy") {
        resetSubActiveTab = "SINGLE";
      }

      if (activeTab === "Sell") {
        // REMOVE THIS CONDITION WHEN SUB ACTIVE HAVE SELL CONTINEOUS TAB.
        return {
          ...state,
          activeTab: activeTab,
          subActiveTab: subActiveTab ?? initialState.subActiveTab,
        };
      }

      return {
        ...state,
        activeTab: activeTab ?? state.activeTab,
        subActiveTab: subActiveTab ?? resetSubActiveTab,
      };
    }
    // Updated Fund Id to order request.
    case orderRequestConstants.UPDATE_NAVIGATION_FUND_TO_ORDER_REQUEST_MODAL:
      return !action.payload
        ? state
        : {
            ...state,
            navigationFund: action.payload,
          };
    case orderRequestConstants.CLEAR_NAVIGATION_FUND_TO_ORDER_REQUEST_MODAL:
      return {
        ...state,
        navigationFund: null,
      };
    // Fetch Fund Info (Buy, Sell, Switch-Out).
    case orderRequestConstants.FETCH_BUY_FUND_INFO_START:
      return {
        ...state,
        fundInfo: {
          ...state.fundInfo,
          isFetching: true,
        },
      };
    case orderRequestConstants.FETCH_SELL_FUND_INFO_START:
      return {
        ...state,
        isFetching: true,
        fundInfo: {
          ...state.fundInfo,
          isFetching: true,
        },
      };
    case orderRequestConstants.UPDATE_FUND_INFO:
      return {
        ...state,
        fundInfo: {
          ...state.fundInfo,
          isFetching: false,
          data: action.payload,
          errorMessage: null,
        },
      };
    case orderRequestConstants.CLEAR_FUND_INFO:
      return {
        ...state,
        fundInfo: {
          ...state.fundInfo,
          isFetching: false,
          data: null,
          errorMessage: action.payload,
        },
      };

    // Fetch Fund Info2 (Switch-In).
    case orderRequestConstants.FETCH_SWITCH_FUND_INFO_START:
      return {
        ...state,
        fundInfo2: {
          ...state.fundInfo2,
          isFetching: true,
        },
      };
    case orderRequestConstants.UPDATE_FUNDS_INFO_2:
      return {
        ...state,
        fundInfo2: {
          ...state.fundInfo2,
          isFetching: false,
          data: action.payload,
          errorMessage: null,
        },
      };
    case orderRequestConstants.CLEAR_FUND_INFO_2:
      return {
        ...state,
        fundInfo2: {
          ...state.fundInfo2,
          isFetching: false,
          data: null,
          errorMessage: null,
        },
      };

    // Checked Fund able to order. (Buy, Switch)
    case orderRequestConstants.CLEAR_CHECKED_FUND_ABLE:
      return {
        ...state,
        checkedFundAbleToOrder: initialState.checkedFundAbleToOrder,
        showResponseMessage: false,
        orderRequestForm: null,
      };
    case orderRequestConstants.CHECKED_BUYABLE_FUND_START:
      return {
        ...state,
        orderRequestForm: action.payload,
        checkedFundAbleToOrder: {
          ...state.checkedFundAbleToOrder,
          isFetching: true,
        },
      };
    case orderRequestConstants.CHECKED_SELLABLE_FUND_START:
      return {
        ...state,
        orderRequestForm: action.payload,
        checkedFundAbleToOrder: {
          ...state.checkedFundAbleToOrder,
          isFetching: true,
        },
      };
    case orderRequestConstants.CHECKED_SWITCHABLE_FUND_START:
      return {
        ...state,
        orderRequestForm: action.payload,
        checkedFundAbleToOrder: {
          ...state.checkedFundAbleToOrder,
          isFetching: true,
        },
      };
    case orderRequestConstants.CHECKED_FUND_ABLE_TO_ORDER_SUCCESS:
      return {
        ...state,
        checkedFundAbleToOrder: {
          ...state.checkedFundAbleToOrder,
          isFetching: false,
          data: action.payload,
          errorMessage: null,
        },
        showResponseMessage: true,
      };
    case orderRequestConstants.CHECKED_FUND_ABLE_TO_ORDER_FAILURE:
      return {
        ...state,
        checkedFundAbleToOrder: {
          ...state.checkedFundAbleToOrder,
          isFetching: false,
          data: [],
          // errorMessage: action.payload
        },
        errorMessage: action.payload,
      };

    // Confirmed Order Fund.
    case orderRequestConstants.CONFIRM_ORDER_FUND_START:
      return {
        ...state,
        confirmOrderFund: {
          ...state.confirmOrderFund,
          isFetching: true,
        },
      };
    case orderRequestConstants.CONFIRM_ORDER_FUND_SUCCESS:
      return {
        ...state,
        confirmOrderFund: {
          ...state.confirmOrderFund,
          isFetching: false,
          data: action.payload,
          errorMessage: null,
        },
      };
    case orderRequestConstants.CONFIRM_ORDER_FUND_FAILURE:
      return {
        ...state,
        confirmOrderFund: {
          ...state.confirmOrderFund,
          isFetching: false,
          data: null,
          errorMessage: null,
        },
        errorMessage: action.payload,
      };
    case orderRequestConstants.RESET_CONFIRM_ORDER_FUND:
      return {
        ...state,
        confirmOrderFund: {
          ...state.confirmOrderFund,
          data: null,
          errorMessage: null,
        },
      };
    // SEARCH FUND INFORMATION
    case orderRequestConstants.CLEAR_SEARCH_FUNDS_INFO:
      return {
        ...state,
        searchFundInfo: null,
        fundInfo: {
          ...state.fundInfo,
          isFetching: false,
          data: null,
          errorMessage: null,
        },
        fundId: null,
      };
    case orderRequestConstants.UPDATE_SEARCH_FUNDS_INFO:
      return {
        ...state,
        searchText: action.payload,
      };
    case orderRequestConstants.REMOVE_SEARCH_FUNDS_INFO:
      return {
        ...state,
        searchText: null,
      };
    // PORTIFOLIOS SEARCH
    case orderRequestConstants.UPDATE_SEARCH_PORTFOLIOS:
      return {
        ...state,
        searchText: action.payload,
      };
    case orderRequestConstants.TOGGLE_MODAL_MESSAGE:
      return {
        ...state,
        showResponseMessage: !state.showResponseMessage,
        orderRequestForm: null,
      };
    // LATEST SELECT PLAN
    case orderRequestConstants.UPDATE_LATEST_PLAN:
      return {
        ...state,
        latestPlan: action.payload,
      };
    case orderRequestConstants.CLEAR_LATEST_PLAN:
      return {
        ...state,
        latestPlan: {},
      };
    // LATEST SELECT SETTLE DATE
    case orderRequestConstants.UPDATE_LATEST_SETTLE_DATE:
      return {
        ...state,
        latestSettleDate: action.payload,
      };
    default:
      return state;
  }
};

export default orderRequestReducer;
